import React from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { DateRangePicker } from "react-date-range";
import { ButtonModalClose } from "../components/ButtonModalClose";
import { Container } from "react-bootstrap";

const DateRangeSelectModal = ({ visible, close, range, setRange }) => {
  const clearRange = () => {
    setRange([
      {
        startDate: null,
        endDate: null,
        key: "selection",
      },
    ]);
  };

  return (
    <Modal
      show={visible}
      onHide={close}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title
          id="contained-modal-title-vcenter"
          className={"text-capitalize"}
        >
          Date Range Selection
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div>
          <DateRangePicker
            onChange={(item) => setRange([item.selection])}
            showSelectionPreview={true}
            moveRangeOnFirstSelection={false}
            months={2}
            ranges={range}
            direction="horizontal"
          />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Container fluid>
          <Row className={"mb-3 align-content-center"}>
            <Col>
              <Button
                variant={"outline-offblack"}
                className={"w-100"}
                onClick={clearRange}
              >
                Reset
              </Button>
            </Col>
            <Col>
              <ButtonModalClose
                className={"w-100"}
                close={close}
                buttonText={"Close"}
              />
            </Col>
          </Row>
        </Container>
      </Modal.Footer>
    </Modal>
  );
};

export default DateRangeSelectModal;
